import React, { useState, useEffect } from 'react'
import { getFirestore, collection, getDocs } from '@firebase/firestore'
import { app } from '../../firebase.js'
import {
  PieChart, Pie, Tooltip, Cell, ResponsiveContainer, Legend
} from 'recharts'
import Table from 'react-bootstrap/Table'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#9B59B6', '#E74C3C', '#2ECC71', '#F39C12']

// Status mapping
const convertedStatuses = ['Student', 'Completed', 'Deferred', 'Expelled', 'Dropped']
const notConvertedStatuses = ['inactive', 'Did Not Join']

function DistributionByCountry() {
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchData = async () => {
      const db = getFirestore(app)
      const usersRef = collection(db, 'users')
      const snapshot = await getDocs(usersRef)

      let countryMap = {}

      snapshot.forEach(doc => {
        const user = doc.data()
        if (user.userType !== 'student') return // only students

        const country = user.nationality || 'Unknown'
        const status = (user.userStatus || '').trim()

        const isConverted = convertedStatuses.includes(status)
        const isNotConverted = notConvertedStatuses.includes(status)

        if (!countryMap[country]) {
          countryMap[country] = { converted: 0, unconverted: 0 }
        }

        if (isConverted) {
          countryMap[country].converted += 1
        } else if (isNotConverted) {
          countryMap[country].unconverted += 1
        }
      })

      // For pie chart: only converted counts
      const chartData = Object.keys(countryMap)
        .map(country => ({
          name: country,
          value: countryMap[country].converted
        }))
        .filter(item => item.value > 0) // exclude countries with 0 converted
        .sort((a, b) => b.value - a.value) // sort by converted descending
        .slice(0, 5) // top 5

      setData({ chart: chartData, table: countryMap })
    }

    fetchData()
  }, [])

  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <div className="p-4">
          <h2>Students Distribution by Country</h2>
          <div style={{ width: '100%', height: 400 }}>
            <ResponsiveContainer>
              <PieChart>
                <Pie
                  data={data.chart || []}
                  dataKey="value"
                  nameKey="name"
                  cx="50%"
                  cy="50%"
                  outerRadius={150}
                  label
                >
                  {(data.chart || []).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <Table striped bordered hover className="mt-4">
            <thead>
              <tr>
                <th>Country</th>
                <th>Converted Students</th>
                <th>Unconverted Students</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {data.table &&
                Object.keys(data.table).map((country, index) => (
                  <tr key={index}>
                    <td>{country}</td>
                    <td>{data.table[country].converted}</td>
                    <td>{data.table[country].unconverted}</td>
                    <td>{data.table[country].converted + data.table[country].unconverted}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}

export default DistributionByCountry